module.exports = __webpack_public_path__ + "media/cuttlefish/logo-47cc9916.svg";